<template>
		<div class="subtabs">
			<div class="mdc-tab-bar main-tabs" role="tablist" id="examViewTab">
					<div class="mdc-tab-scroller ">
							<div class="mdc-tab-scroller__scroll-area">
								<div class="mdc-tab-scroller__scroll-content justify-content-center">
										<button class="mdc-tab mdc-tab--active"  tabindex="0" @click="moveTab('RANKING')">
												<span class="mdc-tab__content">
														<span class="mdc-tab__text-label font-m t-body2">{{$t('1283')}}</span>
												</span>
												<span class="mdc-tab-indicator mdc-tab-indicator--active">
														<span
																class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
												</span>
												<span class="mdc-tab__ripple"></span>
										</button>
										<button class="mdc-tab"  tabindex="0" @click="moveTab1('STORE')">
												<span class="mdc-tab__content">
														<span class="mdc-tab__text-label font-m t-body2">{{$t('1284')}}</span>
												</span>
												<span class="mdc-tab-indicator ">
														<span
																class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
												</span>
												<span class="mdc-tab__ripple"></span>
										</button>
								</div>
						</div>
					</div>
			</div>
				<div class="divider divider-subtabs"></div>
		</div>
</template>


<script>
/**
 * 나의 학습 목록 컴포넌트(my learning list tab Components)
 *
 * @author minkyoung.park@emcast.com
 */

//Components/Mixin/Extend/API define
import {MDCTabBar, MDCTabBarFoundation} from '@material/tab-bar'

export default {
	data() {
		return {
			tabBar: null
		}
	},
	
	mounted() {
		this.tabBar = new MDCTabBar(document.querySelector('.mdc-tab-bar'))
		this.setTabActive()
	},

	methods: {
		setTabActive() {
			let status = this.$route.query.status
			if (status === 'RANKING') {
				this.tabBar.activateTab(0)
			}else if (status == 'STORE') {
				this.tabBar.activateTab(1)
			}else {
				this.tabBar.activateTab(0)
			}
		},
		

		moveTab(type) {
			this.$router.push('/leader?status=RANKING')
		},
		moveTab1(type) {
			this.$router.push('/leader?status=STORE')
		}
		
	}

}
</script>